import { atom } from "recoil";
import { getDefaultOrderSearchBindingModel } from "../services/OrderService";

const OrderSearchState = atom({
    key: 'OrderSearchState',
    default: getDefaultOrderSearchBindingModel(),
});

export default OrderSearchState;